import debug from 'debug';
import { toCamelCase } from './strings';
const MODULE_NAME = 'app.core/lib/objects';
const log = debug(MODULE_NAME);


const ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
export function elementAttrtibutesToObject(element, filterFn = () => true, transformFn = (name) => toCamelCase(name)) {
  const output = {};
  const attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log(`converting element attributes to object`, attrs);

  return attrs.reduce((result, attribute) => {
    if (filterFn(attribute)) {
      const name = transformFn(attribute.name);
      let value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);

}


/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

export function objectPath (obj, path, val, options = {delimiter: '.'}) {
  const props = path.split(options.delimiter);
  const final = props.pop();
  let part;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      }
      else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? (obj[final] = val) : obj[final];
}



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/lib/objects.js